import axios from "axios";
import { API_URL } from "../apiConfig";

const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

export const visitCardAssetUrl = (path) => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  return `${API_URL}${path}`;
};

export async function getPublicVisitCards(userSlug) {
  const { data } = await axios.get(
    `${API_URL}/api/public/visit-cards/${encodeURIComponent(userSlug)}`,
  );
  return data;
}

export async function getPublicVisitCard(userSlug, cardSlug) {
  const { data } = await axios.get(
    `${API_URL}/api/public/visit-cards/${encodeURIComponent(userSlug)}/${encodeURIComponent(cardSlug)}`,
  );
  return data;
}

export async function getVisitCardsMeta() {
  const { data } = await axios.get(`${API_URL}/api/visit-cards/meta`, {
    headers: authHeader(),
  });
  return data;
}

export async function getMyVisitCards() {
  const { data } = await axios.get(`${API_URL}/api/visit-cards/mine`, {
    headers: authHeader(),
  });
  return data;
}

export async function getVisitCardCompanies() {
  const { data } = await axios.get(`${API_URL}/api/visit-cards/companies`, {
    headers: authHeader(),
  });
  return data;
}

export async function saveVisitCardCompany(payload, id) {
  const url = id
    ? `${API_URL}/api/visit-cards/companies/${id}`
    : `${API_URL}/api/visit-cards/companies`;
  const { data } = await axios({
    method: id ? "put" : "post",
    url,
    data: payload,
    headers: authHeader(),
  });
  return data;
}

export async function deleteVisitCardCompany(id) {
  const { data } = await axios.delete(
    `${API_URL}/api/visit-cards/companies/${id}`,
    { headers: authHeader() },
  );
  return data;
}

export async function getIssuedVisitCards() {
  const { data } = await axios.get(`${API_URL}/api/visit-cards`, {
    headers: authHeader(),
  });
  return data;
}

export async function saveVisitCard(payload, id) {
  const url = id
    ? `${API_URL}/api/visit-cards/${id}`
    : `${API_URL}/api/visit-cards`;
  const { data } = await axios({
    method: id ? "put" : "post",
    url,
    data: payload,
    headers: authHeader(),
  });
  return data;
}

export async function deleteVisitCard(id) {
  const { data } = await axios.delete(`${API_URL}/api/visit-cards/${id}`, {
    headers: authHeader(),
  });
  return data;
}

export async function getVisitCardWechatQr(userSlug) {
  const { data } = await axios.get(
    `${API_URL}/api/visit-cards/wechat-qr/${encodeURIComponent(userSlug)}`,
    { headers: authHeader() },
  );
  return data;
}

export async function getVisitCardWechatQrImageBlob(userSlug) {
  const { data } = await axios.get(
    `${API_URL}/api/visit-cards/wechat-qr/${encodeURIComponent(userSlug)}/image`,
    {
      headers: authHeader(),
      responseType: "blob",
    },
  );
  return data;
}
